<ul class="nav nav-tabs nav-sticky">
    <ng-container *ngTemplateOutlet="template; context: { categories: categories, liClass: 'nav-item', level: 1 }"></ng-container>
</ul>
<ng-template #template let-categories="categories" let-liClass="liClass" let-level="level">
    <li [class]="liClass" *ngFor="let category of categories">
        <a *ngIf="isRedirect(category) else noLink"
           class="nav-link"
           target="_blank"
           [href]="category.redirect_url">
                {{ category.name }}
        </a>
        <ng-template #noLink>
            <a class="nav-link"
                href="javascript:void(0)"
                [ngClass]="{active: (category.id === selectedCategory.id || category.id === selectedCategory.parent_category_id)}"
                (click)="handleCategoryClick(category)">
                {{ category.name }}
            </a>
        </ng-template>
        <ul *ngIf="category.sub_categories.length > 0">
            <ng-container *ngTemplateOutlet="template; context: { categories: category.sub_categories, liClass:'', level: (level+1) }"></ng-container>
        </ul>
        <ul *ngIf="level > 1 && category.content.length > 0">
            <li *ngFor="let content of category.content">
                <a *ngIf="isRedirect(content) else noLinkContent"
                    target="_blank"
                    [href]="content.redirect_url">
                    {{ content.title }}
                </a>
                <ng-template #noLinkContent>
                    <a [ngClass]="{active: content.id === selectedContentId}" href="#{{ content.slug }}"
                        (click)="handleContentClick(content.id)">
                        {{ content.title }}
                    </a>
                </ng-template>
            </li>
        </ul>
    </li>
</ng-template>
